import { Link } from 'react-router-dom';

export default function SeoIntro() {
  return (
    <section id="guide" className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <div
              className="relative w-full rounded-3xl overflow-hidden"
              style={{ aspectRatio: '4/3' }}
            >
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20collage%20photography%20of%20diverse%20fashion%20lifestyle%20products%20including%20leather%20goods%20sneakers%20accessories%20and%20small%20electronics%20artistically%20arranged%20in%20a%20sweeping%20diagonal%20composition%20on%20a%20textured%20warm%20oatmeal%20colored%20linen%20background%2C%20soft%20directional%20window%20light%20creating%20gentle%20gradient%20shadows%2C%20sophisticated%20magazine%20editorial%20aesthetic%2C%20rich%20material%20variety%20and%20color%20harmony%2C%20elegant%20curated%20discovery%20feel&width=1000&height=750&seq=seo-intro-collage-v2&orientation=landscape"
                alt="Kakobuy Spreadsheet product collage"
                title="Kakobuy Spreadsheet - Smart Shopping Resource Hub"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 tracking-wide uppercase">
              SEO Resource Hub
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5 leading-tight">
              Why Kakobuy Sheet Dominates Smart Shopping
            </h2>

            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                In the rapidly evolving world of online bargain hunting, having access to a well-organized{' '}
                <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> can transform your shopping
                experience entirely. Rather than scrolling endlessly through product listings, a{' '}
                <strong className="text-foreground-900">Kakobuy Finds Spreadsheet</strong> consolidates thousands
                of verified items into one easy-to-navigate format.
              </p>
              <p>
                What sets the <strong className="text-foreground-900">Kakobuy Sheet</strong> apart is its
                community-driven curation. Each product spreadsheet entry is reviewed, categorized, and tagged
                with essential details — price ranges, seller ratings, shipping estimates, and material
                specifications — giving shoppers the confidence to make informed decisions without wasting
                hours on research.
              </p>
              <p>
                Whether you are hunting for limited-edition sneakers, premium outerwear, trending accessories,
                or niche lifestyle products, the <strong className="text-foreground-900">Kakobuy Product Spreadsheet</strong> ecosystem
                offers a streamlined path from discovery to purchase. The spreadsheet format itself is
                brilliantly simple: sort by category, filter by price, compare side by side, and jump
                directly to the product page — all without leaving your workflow.
              </p>
              <p>
                Moreover, the <strong className="text-foreground-900">Kakobuy Spreadsheet 2026</strong> edition
                includes expanded categories, better mobile compatibility, and real-time update indicators,
                making it the most robust shopping intelligence tool available for free. Compare it with
                CSSBuy, Superbuy, and Oopbuy alternatives, and you will quickly see why thousands of
                savvy shoppers prefer the Kakobuy ecosystem for their daily discovery needs.
              </p>
            </div>

            <div className="mt-6 flex flex-wrap gap-2">
              <Link
                to="/blog/complete-kakobuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 border border-background-200 rounded-full text-sm font-semibold text-foreground-800 hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
              >
                Read Full Kakobuy Guide
                <i className="ri-arrow-right-line text-sm"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                Visit kaspreadsheet.com
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}